import angular from 'angular';

angular
  .module('cxInvoicing')
  .factory('invoiceDialogsSvc', ['$q', 'ModalService', invoiceDialogsSvc]);

function invoiceDialogsSvc($q, ModalService) {
  function showModal(modalOptions) {
    var deferred = $q.defer();
    ModalService.showModal(modalOptions).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) deferred.resolve(result);
        else deferred.reject(null);
      }, deferred.reject);
    });
    return deferred.promise;
  }

  function showTransactionDialog(transaction, companyId) {
    return showModal({
      template: require('./transactionDialog.html'),
      controller: 'TransactionDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        transaction: transaction,
        companyId: companyId,
      },
    });
  }

  return {
    newTransaction: function(companyId) {
      return showTransactionDialog(null, companyId);
    },
    editTransaction: function(transaction) {
      return showTransactionDialog(transaction, transaction.companyId);
    },
    newDraftInvoiceLine: function(invoice) {
      return showModal({
        template: require('./draftInvoiceLineDialog.html'),
        controller: 'DraftInvoiceLineDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    invoiceAudit: function(invoice) {
      return showModal({
        template: require('./invoiceAuditDialog.html'),
        controller: 'InvoiceAuditDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    batchSendInvoices: function(method, filters, batchParams, languages = [], companyId = null) {
      return showModal({
        template: require('./batchSendInvoicesDialog.html'),
        controller: 'BatchSendInvoicesDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          method,
          filters,
          batchParams,
          languages,
          companyId,
        },
      });
    },
    mailHistory: function(invoice) {
      return showModal({
        template: require('./mailHistoryDialog.html'),
        controller: 'MailHistoryDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    mailInvoice: function(invoice, useSendInvoiceStrategy) {
      return showModal({
        template: require('./sendInvoiceDialog.html'),
        controller: 'SendInvoiceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
          useSendInvoiceStrategy: useSendInvoiceStrategy,
          context: 0,
        },
      });
    },
    mailReminder: function(invoice) {
      return showModal({
        template: require('./sendInvoiceDialog.html'),
        controller: 'SendInvoiceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
          useSendInvoiceStrategy: false,
          context: 1,
        },
      });
    },
    newTransactionPayment: function(transaction, invoice) {
      var deferred = $q.defer();

      ModalService.showModal({
        template: require('./transactionPaymentDialog.html'),
        controller: 'TransactionPaymentDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          transaction: transaction,
          invoice: invoice,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(function(result) {
          deferred.resolve(result);
        }, deferred.reject);
      });
      return deferred.promise;
    },
    newInvoicePayment: function(invoice, transaction) {
      return showModal({
        template: require('./invoicePaymentDialog.html'),
        controller: 'InvoicePaymentDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
          transaction: transaction,
        },
      });
    },
    previewDraftInvoice: function(invoice, finalize) {
      return showModal({
        template: require('./previewDraftInvoiceDialog.html'),
        controller: 'PreviewDraftInvoiceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
          finalize: finalize,
        },
      });
    },
    uploadCODA: function(companyId) {
      return showModal({
        template: require('./codaDialog.html'),
        controller: 'CodaDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          companyId,
        },
      });
    },
    editInvoice: function(invoice) {
      return showModal({
        template: require('./editInvoiceDialog.html'),
        controller: 'EditInvoiceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    numberInvoices: function(filters, batchParams, bookyearinfos, invoicesOrCreditNotes) {
      return showModal({
        template: require('./numberInvoicesDialog.html'),
        controller: 'NumberInvoicesDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          filters,
          batchParams,
          bookyearinfos,
          invoicesOrCreditNotes, // 1: only invoices; 2: only credit notes; 3: both/unknown
        },
      });
    },
    deleteWithNeverInvoice: function(message, btnMessage = null, extraButtons = []) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./deleteWithNeverInvoiceDialog.html'),
        controller: 'DeleteWithNeverInvoiceDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          message,
          btnMessage,
          extraButtons, //Array of {value, message, icon, title}
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(function(result) {
          //Null or undefined=cancelled
          if (typeof result === 'undefined' || result === null) deferred.reject(null);
          //False = move to next period
          //True = never invoice
          //Or value from clicked extra button
          deferred.resolve(result);
        }, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
        });
      });
      return deferred.promise;
    },

    batchDeleteDraftInvoice: function() {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./batchDeleteDraftInvoiceDialog.html'),
        controller: 'BatchDeleteDraftInvoiceDialogCtrl',
        locationChangeSuccess: false,
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(function(result) {
          //Null or undefined=cancelled
          if (typeof result === 'undefined' || result === null) deferred.reject(null);
          deferred.resolve(result);
        }, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
        });
      });
      return deferred.promise;
    },
    showInvoicingHistory: function(invoiceStreamId, invoice = null, relationId = null) {
      return showModal({
        template: require('./invoicingHistoryDialog.html'),
        controller: 'InvoicingHistoryDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoiceStreamId,
          invoice,
          relationId,
        },
      });
    },
    updateRegistrationRelation: function(registration, showAddToDraft = false) {
      return showModal({
        template: require('./updateRegistrationRelationDialog.html'),
        controller: 'UpdateRegistrationRelationDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          registration,
          showAddToDraft,
        },
      });
    },
    merge: function(invoice) {
      return showModal({
        template: require('./mergeInvoicesDialog.html'),
        controller: 'MergeInvoicesDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    writeOffInternally: function(invoice) {
      return showModal({
        template: require('./writeOffInternallyDialog.html'),
        controller: 'WriteOffInternallyDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          invoice: invoice,
        },
      });
    },
    batchWriteOffInternally: function(filters, batchParams) {
      return showModal({
        template: require('./writeOffInternallyDialog.html'), //Same html as single dialog
        controller: 'BatchWriteOffInternallyDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          filters,
          batchParams,
        },
      });
    },
  };
}
